import UDFRadio from "features/clients/details/userDefinedFields/components/radio";
import UDFCheckbox from "features/clients/details/userDefinedFields/components/checkbox";
import UDFDatePicker from "features/clients/details/userDefinedFields/components/datePicker";
import UDFInput from "features/clients/details/userDefinedFields/components/input";
import UDFOptions from "features/clients/details/userDefinedFields/components/options";
import UDFSelect from "features/clients/details/userDefinedFields/components/select";
import UDFTextArea from "features/clients/details/userDefinedFields/components/textArea";
import UDFTimePicker from "features/clients/details/userDefinedFields/components/timePicker";
import AgGridUtility from "./agGridUtility";
import UDFInputNumber from "../features/clients/details/userDefinedFields/components/inputNumber";

const K = {
  NullPlaceholder: "N/A",
  Server: process.env.REACT_APP_SERVER,
  Environment: {
    DEVELOPMENT: "development",
    QA: "qa",
    STAGING: "staging",
  },
  Network: {
    URL: {
      Base: process.env.REACT_APP_BASE_URL,
      BaseAPI: process.env.REACT_APP_BASE_API_URL,
      DomainName: process.env.REACT_APP_CLIENT_DOMAIN_NAME,
      Timeout: process.env.REACT_APP_TIMEOUT,
      Protocol: process.env.REACT_APP_PROTOCOL,
      Client: {
        BaseHost: process.env.REACT_APP_CLIENT_BASE_HOST,
        BasePort: process.env.REACT_APP_CLIENT_BASE_PORT,
      },
      Auth: {
        Login: "/user/login",
        ForgotPassword: "/user/send_password_reset_token",
        ResetPassword: "/user/reset_password",
        LoggedInUserDetails: "/get-logged-in-user-details",
        ChangePassword: "/change-user-password-by-settings",
      },
      Lookup: {
        Sources: "/lookup/sources",
        AddSources: "/lookup/adsources",
        Stage: "/lookup/stages",
        AtsNames: "/lookup/ats",
        CandidateStatus: "/lookup/candidate-status",
        JobStatus: "/lookup/job-status",
        JobLocations: "/lookup/job-locations",
        JobDepartments: "/lookup/job-departments",
        JobGroups: "/lookup/job-groups",
        JobTitle: "/lookup/job-titles",
        ContactTypes: "/lookup/contact-types",
        UserDesignation: "/lookup/user-designations",
        Ownership: "/lookup/ownership",
        BillingTypes: "/lookup/one-time-payment-billing-type",
        GetHistory: "/look-up-history",
        ClassStatus: "/lookup/class-status",
      },
      Clients: {
        GetAllName: "/client/get-all-client-name",
        Create: "/client/store",
        ClientDetails: {
          Overview: "/client-detail",
          JobBillingRules: "/tiers/get-client-tiers",
          CreateJob: "/job-source/create",
          ClientBillingRules: "/client-billing-rules-entries",
          ClientLevelBillingRules: "/client-level-billing-rules-edit",
          JobLevelBillingRules: "/job-level-billing-rules-edit",
          EditExistingJobLevelBillingRuleDate:
            "/edit-existing-billing-rule-job-date",
          AddTier: "/job-level-billing-rules-edit",
          Client: "/client",
          JobTier: "/job-tier",
          ClientInformationEdit: "/client-detail-edit",
          UpdateTierDetails: "/tier/update",
          EditJob: "/job-source/update",
          AbortClientBillingRule: "/client/client-billing-rule/abort",
          AbortJobBillingRule: "/client/job-billing-rule/abort",
          EditUpcomingClientRule:
            "/client/upcoming-client-level-billing-rules-edit",
          EditUpcomingJobRule: "/client/upcoming-job-level-billing-rules-edit",
          EditClientBillingRuleStartDate: "/edit-existing-billing-rule-date",
        },
      },
      ClientLookupTable: {
        JobDepartmentByMultipleClient:
          "/lookup/job-department-by-multiple-clients",
      },
      Jobs: {
        GetByClientIds: "/jobs-by-client-ids",
        GetByClientIdsWithServerSide: "/jobs-by-client-ids-with-server-side",
        GetById: "/job-source/get-job-detail-by-id",
        UpdateSettings: "/job-source/update-job-settings",
        CancelById: "/job-source/cancel-job-by-id",
        UpdateJobStatus: "/job-source/update-job-status-by-id",
        DeleteJob: "/delete-conditional-job-source",
        CustomCancelBilling: "/job-source/custom-cancellation-billing",
        GetOnlyJobsByClientIds: "/client-jobs-for-candidate-job-change",
      },
      Invoices: {
        GetDetails: "/invoice-detail",
        EditInvoice: "/start-date-invoice",
        DeleteInvoice: "/conditional-delete-invoice",
        BulkUpdate: "/invoice/bulk-status-update",
      },
      BillingSchedule: {
        UpdateJobScheduledbilling: "/scheduled-job-billing/update",
        UpdateClientScheduledbilling: "/scheduled-client-billing/update",
        GetScheduledBillingByCandidateId:
          "/scheduled-job-billing/get-by-candidate-id",
      },
      BillingApproval: {
        GetSubmittedBillHistory: "/get-submitted-bill-history",
        EditJobSubmittedBilling: "/edit-job-submitted-billing",
        EditClientSubmittedBilling: "/edit-client-submitted-billing",
        CurrencyConversion: "/currency-conversion",
        CreateInvoice: "/submitted-billing-invoice",
        IssueCredit: "/job-issue-credit",
        ReCalculateBillings: "/status/re-calculate-billings",
        RunTimeCalculations: "/status/run-time-billing-calulcations",
        SubmitCalculateDiscount: "/volume-bases/validate-discount",
        GetVolumeBasedBillings: "/volume-bases/submitted-billings/:clientId",
      },
      BillingClient: {
        GetAll: "/client-level-billing-type",
        Create: "/client-level-billing-type/store",
        GetOneTimeEntries:
          "/submit-to-one-time-billing/get-onetime-entries-by-client-id",
        SubmitOneTimeBilling: "/submit-to-one-time-billing/submit",
        EditBillingClient: "/client-level-billing-type/update",
      },
      BillingJob: {
        GetAll: "/job-billing-type",
        Create: "/job-billing-type/store",
        EditBillingJob: "/job-billing-type/update",
        SubmitOnetime: "/candidate-activity-submit-one-time-billing",
      },
      VBD: {
        create: "/volume-bases/create",
        GetByClientId: "/volume-bases/clients-details",
      },
      Users: {
        GetAll: "/user/get-all",
        GetByDesignationId: "/user/get-user-by-designation_id",
        CreateUser: "/user/create-user",
        UpdateUser: "/user/update-user",
        UserDetailById: "/user-detail",
        EditUserProfile: "/update-user-by-setting",
        GetLogs: "/logs/get-general-activity",
        SaveColumnSort: "/config/columns-sorting-by-user",
        GetUserPlanTimeline: "/user-plan-timeline",
        GetConfigrations: "/config/get-user-configuration",
        HandleUserActive: "/user/handle-activaton-user",
        GetClientHiringManager: "/user/get-hiring-managers-by-client-id",
      },
      ClientContacts: "/contacts",
      Currency: "/currencies",
      Tiers: {
        GetClientTiers: "/tiers/get-client-tiers",
      },
      V2: {
        Candidates: {
          All: "/v2/candidates",
          Activities: "/v2/candidates/:id/activities",
          Merge: "/v2/candidates/merge",
          Edit: "/v2/jobs/:jobId/candidates/:candidateId",
        },
        Comments: {
          Edit: "/v2/candidates/comments/:id",
        },
        Export: {
          Reports: {
            JobsVacancies: "/v2/export/reports/jobs-vacancies",
            CandidateJobEntries: "/v2/export/reports/candidate-job-entries",
            Engagements: "/v2/export/reports/engagements",
            JobBillings: "/v2/export/reports/billings/submitted/job/:clientId",
            JobInvoiceDetail: "/v2/export/reports/invoices/job/:invoiceId",
            CommissionStatements: "/v2/export/reports/commission-statements",
            CommissionApprovals: "/v2/export/reports/commission-approvals",
            CommissionApprovalsSummary:
              "/v2/export/reports/commission-approvals/summary",
            Invoices: "/v2/export/reports/invoices",
            ScheduledJobBills: "/v2/export/reports/billings/scheduled/job",
            ClientContacts: "/v2/export/reports/contacts",
            Users: "/v2/export/reports/users",
          },
        },
        Engagements: {
          All: "/v2/engagements",
          Edit: "/v2/engagements/:id",
          Recruiters: "/v2/engagements/recruiters",
        },
        Commission: {
          Edit: "/v2/commissions/:id",
          Timelines: {
            EditCurrent: "/v2/commissions/:commissionId/timelines/current",
          },
        },
        Clients: {
          All: "/v2/clients",
          Jobs: "/v2/clients/:clientId/jobs",
          Reports: {
            Configs: {
              Create: "/v2/clients/:clientId/reports/config",
              Update: "/v2/clients/:clientId/reports/config",
              All: "/v2/clients/reports/configs",
            },
            GetEmbed: "/v2/clients/:clientId/reports/:reportType/embed",
          },
          RecruiterGoals: "/v2/recruiter-goals",
          RecruiterGoal: {
            Update: "/v2/recruiter-goals/:recruiterGoalId",
            Delete: "/v2/recruiter-goals/:recruiterGoalId",
          },
          Billings: {
            Submitted: {
              Delete: "/v2/clients/billings/submitted/:billId",
            },
            Scheduled: {
              All: "/v2/clients/billings/scheduled",
            },
          },
          ViewFieldOrders: {
            Update: "/v2/clients/:clientId/view-field-orders/:viewType",
            ByViewType: "/v2/clients/:clientId/view-field-orders/:viewType",
          },
          Workflow: {
            Summary: "/v2/clients/:clientId/workflow/summary",
            Statuses: "/v2/clients/:clientId/workflow/statuses",
            Transitions: "/v2/clients/:clientId/workflow/transitions",
            SubStatus: {
              Update:
                "/v2/clients/:clientId/workflow/sub-statuses/:subStatusId",
            },
            Transition: {
              Update:
                "/v2/clients/:clientId/workflow/transitions/:transitionId",
            },
            Status: {
              Position:
                "/v2/clients/:clientId/workflow/statuses/:statusId/position",
            },
            CustomTransition: {
              Update:
                "/v2/clients/:clientId/workflow/custom-transitions/:customTransitionId",
            },
          },
          Recruiters: {
            All: "/v2/clients/:clientId/recruiters",
          },
          Recruiter: {
            WeeklyActivity: {
              Summary:
                "/v2/clients/:clientId/recruiters/:recruiterId/weekly/activity",
              Candidates:
                "/v2/clients/:clientId/recruiters/:recruiterId/weekly/activity/:metricKey/candidates",
            },
            Monthly: {
              OfferMetrics:
                "/v2/clients/:clientId/recruiters/:recruiterId/monthly/offer-metrics",
              Progress: {
                Summary:
                  "/v2/clients/:clientId/recruiters/:recruiterId/monthly/progress",
                Hires:
                  "/v2/clients/:clientId/recruiters/:recruiterId/monthly/progress/hires",
                Billings:
                  "/v2/clients/:clientId/recruiters/:recruiterId/monthly/progress/billings",
              },
            },
            Tasks: {
              All: "/v2/clients/:clientId/recruiters/:recruiterId/tasks",
            },
            Pipeline: {
              Candidates:
                "/v2/clients/:clientId/recruiters/:recruiterId/pipeline/candidates",
            },
          },
        },
        Jobs: {
          Billings: {
            Submitted: {
              Delete: "/v2/jobs/billings/submitted/:billId",
            },
            Scheduled: {
              All: "/v2/jobs/billings/scheduled",
            },
          },
          Statistics: "/v2/jobs/:jobId/statistics",
          HiringInfo: "/v2/jobs/:jobId/hiring-info",
          Candidates: "/v2/jobs/:jobId/candidates",
        },
        Billings: {
          Submitted: {
            Client: {
              All: "/v2/billings/submitted/client/:clientId",
              Total: "/v2/billings/submitted/client/total/:clientId",
              Ids: "/v2/billings/submitted/client/ids/:clientId",
            },
            Job: {
              All: "/v2/billings/submitted/job/:clientId",
              Total: "/v2/billings/submitted/job/total/:clientId",
              Ids: "/v2/billings/submitted/job/ids/:clientId",
            },
          },
        },
        Users: {
          Delete: "/v2/users/:userId",
          Terms: {
            Accept: "/v2/users/me/terms/accept",
          },
        },
        Terms: {
          GetUrl: "/v2/terms",
          Accept: "/v2/terms/accept",
        },
        Workflow: {
          EntryPoints: "/v2/workflow/entry-points",
        },
        CandidateJobEntry: {
          Workflow: {
            AvailableTransitions:
              "/v2/candidate-job-entry/:id/workflow/transitions/available",
          },
          Pipeline: "/v2/candidate-job-entry/:id/pipeline",
          TabCounts: "/v2/candidate-job-entry/:id/tab-counts",
          TransitionDateFields:
            "/v2/candidate-job-entry/:id/transition-date-fields",
        },
        Invoices: {
          All: "/v2/invoices",
          JobBills: "/v2/invoices/:id/bills/job",
        },
      },
      Candidate: {
        Get: "/candidate",
        GetActivity: "/candidate-entries-recrutor-comments",
        GetById: "/candidate/get-candidate-detail-by-id",
        AddToBlacklist: "/candidate/add-candidate-to-blacklist",
        RemoveToBlacklist: "/candidate/remove-candidate-to-blacklist",
        Create: "/candidate/create",
        Edit: "/candidate/edit",
        ChangeStatus: "/status/change-candidate-status",
        AddComment: "/comment/updateOrCreate",
        GetComments: "/comment/candidate-comments",
        GetLogs: "/logs/candidate",
        GetByJobId: "/candidate/get-all-candidates-by-job-id",
        GetJobRecruiterByJobId: "/candidate/get-job-recruiter-by-job-id",
        GetBillings: "/candidate-billings",
        EditCandidateDetail: "/candidate/edit-basic-info",
        EditOfferSalary: "/edit-offer-salary",
        GetCandidateLog: "/logs/candidate-activity-by-id",
        SuggestAnEmail: "/generate-email",
        DeleteCandidate: "/delete-conditional-candidate",
        TransferCandidateJob: "/change-candidate-job",
        GetCandidateBilling: "/candidate-all-submitted-bills",
        GetJobsByClientIds: "/client-jobs-for-candidate-job-change",
        GetByClassId: "/class/candidates",
        ChangeCandidateStatusInBulk: "/candidate-future-use",
      },
      RoleAndPermissions: {
        GetAllRole: "/roles",
        GetAllPermission: "/permissions",
        CreateRole: "/roles",
        UpdateRole: "/roles",
        GetRoleById: "/roles",
      },
      CommissionPlans: {
        GetAll: "/commission/get-all-commission-plans",
        CreateCommissionPlan: "/create-commission-plan",
        GetCommissionPlansById: "/commission/get-commission-plans-by-id",
        AddNewCommissionPlan: "/commission/add-new-commission-plan",
        DeleteUpcommingPlan: "/commission/delete-commission-plan",
        GetCommissionApprovals: "/commission-approval",
        EditCommissionApproval: "/edit-commission-approval",
        GetCommissionStatements: "/commission-statement-list",
        GetCommissionStatementDetail: "/commission-statement-detail",
        CreateCommissionStatement: "/commission-statement",
        DeleteCommissionStatement: "/commission-statement-delete",
      },
      Files: {
        Upload: "/files/upload",
        Remove: "",
        UploadCSV: "/job-source/upload-csv",
        DeleteCV: "/files/delete",
      },
      Status: {
        GetSubStatusBreakdown: "/status/sub-status-breakdown",
        UndoStatus: "/undo-candidate-status",
        ChangeStatusDate: "/status/change-candidate-status-dates",
      },
      UDF: {
        GetFields: "/udf/field-types",
        Create: "/udf/create",
        Update: "/udf/update",
        GetUDF: "/udf/fields-by-client-id",
        GetEditUDFList: "/udf/edit-fields-value",
        EditUDFValues: "/udf/update-udf-field-value",
      },
      Attachment: {
        create: "/create-attachment",
        get: "/attachments",
        preSignedUrl: "/files/getPreSignedUrl",
        deleteS3: "/files/delete",
        delete: "/attachments-delete",
      },

      Class: {
        addClass: "/class/create",
        editClass: "/class/:classId",
        getClassDetailById: "/class/detail",
        getClientClassList: "/class/all",
        getClassSetting: "/class/get-settings",
        assignCandidate: "/class/candidate-assignment",
        detachCandidate: "/class/candidate-unassigned",
        getClientClassManager: "/class/managers",
        updateClassSetting: "/class/update-class-job-settings",
        cancelClassById: "/class/update-class-job-settings",
        GetStatistics: "/class/states",
        StatusAndSubStatusBreakDown: "/class/status-breakdown",
        UpdateClassStatus: "/class/update-class-status-by-id",
      },
      UploadExcelFile: {
        jobs: "/candidate-upload/jobs",
        recruiters: "/candidate-upload/recruiters",
        class: "/candidate-upload/class",
      },
    },

    Method: {
      GET: "GET",
      POST: "POST",
      PATCH: "PATCH",
      DELETE: "DELETE",
      PUT: "PUT",
    },
    ResponseType: { Blob: "blob", Json: "json" },
    Header: {
      ContentType: "Content-Type",
      ApplicationJson: "application/json",
      Default: (token = "") => ({
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      }),
      Authorization: (token = "") => ({
        Authorization: `Bearer ${token}`,
      }),
      Type: {
        Json: "json",
        File: "file",
      },
    },
    StatusCode: {
      NotModified: 304,
      Forbidden: 403,
      Unauthorized: 401,
      InternalServerError: 500,
    },
  },
  Cookie: {
    Key: {
      User: "user",
      EncryptionKey: "source2_logged_in_user",
    },
  },
  UserType: {
    Source2: { id: 1, name: "Source2", value: "SOURCE2" },
    External: { id: 2, name: "External", value: "EXTERNAL" },
  },
  DateFormat: {
    LongDisplay: "MMMM Do YYYY, h:mm:ss a",
    Display: "LL",
    TimeStampLongFormat: "lll",
    TimeStampShortFormat: "ll",
    Response: "YYYY-MM-DD",
    ResponseWithTime: "YYYY-MM-DD HH:mm:ss",
    CommentFormat: "h:mm A - MMMM Do YYYY",
    USFormat: "MM/DD/YYYY",
    ShortUSFormat: "MM/DD/YY",
    DashUSFormat: "MM-DD-YYYY",
    DashUSFormatTimeStamp: "MM-DD-YYYY, LT",
    FileCreatedTime: "MM-DD-YYYYTh-mm-a",
    DashMonthFormat: "YYYY-MM",
    MonthYearFormat: "MM-YYYY",
    LongMonth: "MMMM",
    MonthDay: "MMM D",
  },
  TimeFomat: { Display: "hh:mm A", Response: "HH:mm" },
  PhoneFormat: {
    USNational: "(###) ###-####",
    USInternational: "+1 (###) ###-####",
  },
  TooltipColor: "var(--warning-color)",
  CancelJobColor: "var(--red-300)",
  DiscriptionLength: 55,
  Permissions: {
    SuperAdmin: "ADMIN.ADMIN",
    ViewDashboardOwnProgress: "DASHBOARD.READ",
    ViewDashboardTeamProgress: "DASHBOARD.VIEW_TEAM_PROGRESS",
    ViewInvoices: "INVOICES.READ",
    ViewCommissionApproval: "COMMISSIONAPPROVAL.READ",
    ViewCommissionStatement: "COMMISSIONSTATEMENT.READ",
    ViewBillingApproval: "BILLINGAPPROVAL.READ",
    ViewCandidates: "CANDIDATES.READ",
    ViewBillingClients: "BILLINGCLIENTS.READ",
    ViewBillingJobs: "BILLINGJOBS.READ",
    ViewCommissionPlan: "COMMISSIONPLANS.READ",
    ViewLookupTable: "LOOKUPTABLES.READ",
    CreateRole: "CONFIGRATION.ROLESANDPERMISSIONS.CREATE",
    ViewRolesAndPermissions: "ROLESANDPERMISSIONS.READ",
    EditRolesAndPermissions: "ROLESANDPERMISSIONS.EDIT",
    ViewUsers: "USERS.READ",
    ViewJobs: "JOBS.READ",
    ViewLogs: "LOGS.READ",
    ViewClientContacts: "CLIENTCONTACTS.READ",
    ViewScheduledBilling: "SCHEDULEDBILLING.READ",
    CreateJob: "JOBS.CREATE",
    EditJob: "JOBS.EDIT",
    EditJobStatus: "JOBS.EDIT_STATUS",
    EditJobOpenings: "JOBS.EDIT_OPENINGS",
    UploadJobCSV: "CLIENT.JOB.UPLOADCSV",
    CancelJob: "JOBS.CANCEL",
    CreateCandidate: "CANDIDATES.CREATE",
    CreateCandidate: "CANDIDATES.CREATE",
    EditCandidate: "CANDIDATE.EDIT",
    ViewCandidateJobs: "CANDIDATE.JOBDETAIL",
    DeleteCandidate: "CANDIDATES.DELETE",
    TransferCandidate: "CANDIDATES.TRANSFER",
    SubmitCandidateOneTimeBilling: "CANDIDATES.ONETIMEBILLING.SUBMIT",
    ViewCandidateBillings: "CANDIDATES.BILLINGS.VIEW",
    ViewCandidateScheduledBillings: "CANDIDATES.SCHEDULEDBILLINGS.VIEW",
    ViewCandidateComments: "CANDIDATES.COMMENTS.VIEW",
    CreateCandidateComments: "CANDIDATES.COMMENTS.CREATE",
    EditCandidateComments: "CANDIDATES.COMMENTS.EDIT",
    CreateInvoices: "INVOICE.CREATE",
    CreateOneTimeBilling: "INVOICE.CREATE.ONETIMEBILLING",
    CreateCommissionStatement: "COMMISSIONAPPROVAL.CREATE.COMMISSIONSTATEMENT",
    CreateClientBilling: "BILLINGCLIENTS.CREATE",
    EditClientBilling: "BILLINGCLIENTS.EDIT",
    CreateJobBilling: "BILLINGJOBS.CREATE",
    EditJobBilling: "BILLINGJOBS.EDIT",
    CreateCommissionPlan: "COMMISSIONPLANS.CREATE",
    EditCommissionPlan: "COMMISSIONPLANS.EDIT",
    CreateLookup: "LOOKUPTABLES.CREATE",
    EditLookup: "LOOKUPTABLES.EDIT",
    CreateUser: "USERS.CREATE",
    EditUser: "USERS.EDIT",
    ActivateUser: "USERS.ACTIVATE",
    CreateClientContact: "CLIENTCONTACTS.CREATE",
    EditClientContact: "CLIENTCONTACTS.EDIT",
    DeleteClientContact: "CLIENTCONTACTS.DELETE",
    CreateClient: "CLIENTS.CREATE",
    EditClient: "CLIENTS.EDIT",
    ViewBillingRules: "CLIENTS.READ_BILLING_RULES",
    ViewClientLookupTables: "CLIENT.LOOKUP.VIEW",
    EditClientLookupTables: "CLIENT.LOOKUP.EDIT",
    CreateClientLookupTables: "CLIENT.LOOKUP.CREATE",
    CreateJobHiringManagers: "CLIENTS.CREATE_JOB_HIRING_MANAGERS",
    EditJobHiringManagers: "CLIENTS.EDIT_JOB_HIRING_MANAGERS",
    EditClientVBD: "CLIENTS.EDIT_VBD",
    CreateClientVBD: "CLIENTS.CREATE_VBD",
    DeleteInvoice: "INVOICE.DELETE",
    EditInvoice: "INVOICE.EDIT",
    DeleteCommissionStatement: "COMMISSIONAPPROVAL.DELETE.COMMISSIONSTATEMENT",
    DeleteJob: "JOBS.DELETE",
    DeleteUser: "USERS.DELETE",
    UndoCandidate: "JOBS.CANDIDATE.STATUS.UNDO",
    UDFCreate: "UDF.CREATE",
    UDFEdit: "UDF.EDIT",
    UDFView: "UDF.VIEW",
    AddAttchment: "ATTACHMENT.ADD",
    DeleteAttachment: "ATTACHMENT.DELETE",
    ViewAttachment: "ATTACHMENT.VIEW",
    EditClientBillingRule: "CLIENTS.EDIT_BILLING_RULES",
    EditJobBillingRule: "CLIENTS.EDIT_JOB_BILLING_RULES",
    CreateClass: "CLASS.CREATE",
    ViewClass: "CLASS.VIEW",
    EditClass: "CLASS.EDIT",
    CandidateProfileMerge: "CANDIDATE.PROFILE.MERGE",
    ManageEngagementsForAssignedCandidates:
      "ENGAGEMENT.MANAGE_FOR_ASSIGNED_CANDIDATES",
    ManageEngagementsForAssignedClients:
      "ENGAGEMENT.MANAGE_FOR_ASSIGNED_CLIENTS",
    ViewRecruiterPerformanceReporting: "REPORTING.VIEW_RECRUITER_PERFORMANCE",
    ViewClientReporting: "REPORTING.VIEW_CLIENT_REPORTING",
    ViewInternalReporting: "REPORTING.VIEW_INTERNAL_REPORTING",
    ManageReports: "CONFIGURATIONS.MANAGE_REPORTS",
    ManageCandidateBlacklist: "CANDIDATES.MANAGE_BLACKLIST",
    ManageCandidatesForAssignedClients:
      "CANDIDATES.MANAGE_FOR_ASSIGNED_CLIENTS",
    EditScheduledBillings: "SCHEDULEDBILLING.EDIT",
    DeleteSubmitToBillings: "BILLINGAPPROVAL.DELETE",
    EditSubmitToBillings: "BILLINGAPPROVAL.EDIT",
    RevertCandidateFinalDispositionStatus:
      "CANDIDATES.REVERT_FINAL_DISPOSITION_STATUS",
    ViewCandidateWorkflow: "CANDIDATE_WORKFLOW.VIEW",
    ViewRecruiterGoals: "RECRUITERGOALS.READ",
  },
  Designations: {
    Recruiter: "Recruiter",
    SeniorRecruiter: "Senior Recruiter",
  },
  Redux: {
    Roles: "roles",
    Recruiters: "recruiters",
    Clients: "clients",
    Details: "details",
    TotalClients: "totalClients",
    BillingType: "billingType",
    ClientSelection: "clientSelection",
    Listing: "listing",
    SelectedClient: "selectedClient",
    SelectedClients: "selectedClients",
    SelectedRecruiters: "selectedRecruiters",
    Source: "source",
    AdSource: "adSources",
    Stage: "stage",
    AtsName: "ats",
    IsTestPassed: "isTestPassed",
    CandidateStatus: "candidateStatus",
    JobStatus: "jobStatus",
    JobLocation: "jobLocation",
    JobDepartment: "jobDepartment",
    JobGroup: "jobGroup",
    JobTitle: "jobTitle",
    ContactTypes: "contactTypes",
    BillingClients: "billingClients",
    BillingJobs: "billingJobs",
    Lookup: "lookup",
    CreateClientData: "createClientData",
    ClientDetails: "clientDetails",
    BillingUnit: "billingUnit",
    ClientLevelBilligRules: "clientLevelBilligRules",
    UserDesignation: "userDesignation",
    Ownership: "ownership",
    BillingTypes: "billingTypes",
    ShouldUpdate: "shouldUpdate",
    Currencies: "currencies",
    HomeRoute: "homeRoute",
    ShouldReinitialize: "shouldReinitialize",
    ClientUdf: "clientUdf",
    CandidateUdf: "candidateUdf",
    JobSourceUdf: "jobSourceUdf",
    ClassStatus: "classStatus",
  },
  LookupTabKeys: {
    Source: "source",
    AdSource: "ad-source",
    Stage: "stage",
    ATSNames: "ats-names",
    CandidateStatus: "candidate-status",
    JobStatus: "job-status",
    JobLocations: "job-locations",
    JobDepartments: "job-departments",
    JobGroups: "job-groups",
    JobTitle: "job-title",
    ContactTypes: "contact-types",
    UserDesignation: "user-designations",
    Ownership: "ownership",
    BillingTypes: "billing-types",
    ClassStatus: "class-status",
  },

  LookupTableNames: {
    Source: "sources",
    AdSource: "ad_sources",
    Stage: "stage_look_ups",
    ATSNames: "ats_look_ups",
    CandidateStatus: "candidate_statuses",
    JobStatus: "job_statuses",
    JobLocations: "job_locations",
    JobDepartments: "job_departments",
    JobGroups: "job_groups",
    JobTitle: "job_titles",
    ContactTypes: "contact_types",
    UserDesignation: "user_designation_lookups",
    Ownership: "ownership_lookup",
    BillingTypes: "one_time_payment_billing_types",
    ClassStatus: "class_statuses",
  },
  DetailsKeys: {
    Overview: "overview",
    Lookup: "lookup",
    HiringManager: "hiring-manager",
    Jobs: "jobs",
    JobInvoices: "job-invoices",
    ClientInvoices: "client-invoices",
    JobBillingRules: "job-billing-rules",
    ClientBillingRules: "client-billing-rules",
    UserDefineds: "user-defineds",
    Attachment: "attachments",
    Class: "class",
  },
  JobBillingRuleTabKeys: {
    Tiers: "tiers",
    VBD: "vbd",
  },
  BillingTypes: {
    OneTime: "ONE_TIME",
    Recursive: "RECURSIVE",
    TimeBased: "TIME_BASED",
    Retention: "RETENTION",
  },
  CandidateHireType: {
    AppliedHIRE: "appliedHire",
    SourceHired: "sourceHired",
    Referral: "referral",
    Cancellations: "cancellations",
    HiringEvent: "hiringEvent",
    ReHired: "reHired",
  },
  hireType: [
    { value: "applied_hire", label: "Applied Hire" },
    { value: "source_hired", label: "Sourced Hire" },
    { value: "referral", label: "Referral" },
    { value: "hiring_event", label: "Hiring Event" },
    { value: "re_hired", label: "Rehire" },
    { value: "internal", label: "Internal" },
  ],
  UploadHireType: [
    { value: "applied_hire", label: "Applied Hire" },
    { value: "source_hired", label: "Sourced Hire" },
    { value: "referral", label: "Referral" },
    { value: "hiring_event", label: "Hiring Event" },
    { value: "re_hired", label: "Rehire" },
    { value: "re_hire_referral", label: "Rehire Referral" },
    { value: "re_hire_applied", label: "Rehire Applied" },
    { value: "re_hire_sourced", label: "Rehire Sourced" },
    { value: "internal", label: "Internal" },
  ],

  RecurringType: {
    Week: "WEEK",
    Month: "MONTH",
    Day: "DAY",
  },
  CommissionThresholdType: {
    Amount: "AMOUNT",
    TotalHire: "TOTAL_HIRE",
  },
  Format: {
    Dollar: "AMOUNT",
    Percentage: "PERCENT",
  },
  CurrencyType: {
    Dollar: "$",
    CAD: "C$",
  },
  AgGridTable: {
    TrailKey:
      "[TRIAL]_this_AG_Grid_Enterprise_key_( AG-040680 )_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_purchasing_a_production_key_please_contact_( info@ag-grid.com )___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_( 30 June 2023 )____[v2]_MTY4ODA3OTYwMDAwMA==5266e2b19455d0b5c7c8c52bf6367755",
    DefaultProps: {
      pagination: true,
      suppressMultiSort: true,
      paginationPageSize: 25,
      loadingCellRenderer: () => "",
      getContextMenuItems: () => AgGridUtility.defaultMenuItems,
    },
    DefaultColDef: {
      flex: 1,
      minWidth: 150,
      resizable: true,
      cellStyle: { border: "none", textAlign: "center" },
      headerClass: "text-center",
      suppressMovable: false,
      hide: false,
      pinned: null,
    },
    Keys: {
      Candidates: "Candidates",
      Jobs: "Jobs",
      UserVisibleColumn: "User_Visible_Columns",
      GridLayoutOrder: "Grid_Layout_Order",
      ClientLookupVisibleColumn: "Client_Lookup_Visible_Columns",
      ClientLookupJobTitleVisibleColumn:
        "Client_Lookup_Job_Title_Visible_Columns",
      LookupVisibleColumn: "Lookup_Visible_Columns",
      ClientVisibleColumn: "Clients_Visible_Columns",
      GlobalJobsVisibleColumn: "Global_Jobs_Visible_Columns",
      ClientJobsVisibleColumn: "Client_Jobs_Visible_Columns",
      BillingJobsVisibleColumn: "Billing_Jobs_Visible_Columns",
      BillingClientsVisibleColumn: "Billing_Clients_Visible_Columns",
      ClientContactsVisibleColumn: "Client_Contacts_Visible_Columns",
      CommissionPlansVisibleColumn: "Commission_Plans_Visible_Columns",
      RolePermissionsVisibleColumn: "Roles_Permissions_Visible_Columns",
      CommissionApprovalsVisibleColumn: "Commission_Approvals_Visible_Columns",
      CommissionStatementVisibleColumn: "Commission_Statement_Visible_Columns",
      SubmittedClientBillingsVisibleColumn:
        "Submitted_Client_Billings_Visible_Columns",
      SubmittedJobBillingsVisibleColumn:
        "Submitted_Job_Billings_Visible_Columns",
      HiringManagerVisibleColumn: "Hiring_Manager_Visible_Columns",
      UserDefinedsVisibleColumn: "User_Defineds_Visible_Columns",
      AttachmentVisibleColumn: "Attachment_Visible_Columns",
      JobDetailCandidateColumn: "Job_Detail_Candidate_Columns",
      ClassDetailsVisibleColumn: "Class_Details_Visible_Columns",
      ClientClassVisibleColumn: "Client_Class_Visible_Columns",
      ThisWeekEngagementsVisibleColumn: "This_Week_Engagements_VisibleColumns",
      PastDueEngagementsVisibleColumn: "Past_Due_Engagements_VisibleColumns",
      FutureEngagementsVisibleColumn: "Future_Engagements_VisibleColumns",
      ClientReportConfigsVisibleColumn: "Client_Report_Configs_VisibleColumn",
      RecruiterGoalsVisibleColumn: "Recruiter_Goals_Visible_Columns",
      JobScheduledBillingsVisibleColumn: "Job_Scheduled_Billings_VisibleColumn",
      ClientScheduledBillingsVisibleColumn:
        "Client_Scheduled_Billings_VisibleColumn",
      ClientInvoicesVisibleColumn: "Client_Invoices_Visible_Columns",
      ClientJobInvoicesVisibleColumn: "Client_Job_Invoices_Visible_Columns",
      GlobalClientInvoicesVisibleColumn:
        "Global_Client_Invoices_Visible_Columns",
      GlobalClientJobInvoicesVisibleColumn:
        "Global_Client_Job_Invoices_Visible_Columns",
      ClientJobBillingRulesVisibleColumn:
        "Client_Job_Billing_Rules_Visible_Columns",
      LogsVisibleColumn: "Logs_Visible_Columns",
      OpenPendingJobsVisibleColumn: "Open_Pending_Jobs_Visible_Columns",
      PipelineCandidatesVisibleColumn: "Pipeline_Candidates_Visible_Columns",
      InvoiceJobDetailsColumn: "Invoice_Job_Details_Columns",
      InvoiceJobDetailsDiscountedColumn:
        "Invoice_Job_Details_Discounted_Column",
      InvoiceJobDetailsNonDiscountedColumn:
        "Invoice_Job_Details_Non_Discounted_Column",
    },
  },
  AttachmentType: {
    Candidate: "CANDIDATE",
    Client: "CLIENT",
  },
  ReactTrelloEvents: {
    AddCard: "ADD_CARD",
    UpdateCard: "UPDATE_CARD",
    RemoveCard: "REMOVE_CARD",
    MoveCard: "MOVE_CARD",
    UpdateLanes: "UPDATE_LANES",
  },
  FileUpload: {
    Types: {
      PDF: "pdf",
      DOC: "doc",
      DOCX: "docx",
      XLS: "xls",
      XLSX: "xlsx",
      PPT: "ppt",
      PPTX: "pptx",
      TXT: "txt",
      ODT: "odt",
      CSV: "csv",
      JPG: "jpg",
      JPEG: "jpeg",
      PNG: "png",
    },
    Groups: {
      DOCUMENTS: [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "txt",
        "odt",
        "csv",
      ],
      CV: ["doc", "docx", "odt", "pdf"],
      IMAGES: ["jpg", "jpeg", "png"],
      get DOCUMENTS_AND_IMAGES() {
        return [...this.DOCUMENTS, ...this.IMAGES];
      },
    },
  },
  S3Folders: {
    CV: "candidate_cv",
    ProfilePicture: "profile_picture",
    ClientAttachments: "client_",
    CandidateAttachments: "candidate_",
  },
  CandidateStatus: {
    Prospects: "Prospect",
    Candidates: "Candidates",
    S2Interview: "S2 Interview",
    Submitted: "Submitted",
    ClientInterview: "Client Interview",
    InterviewComplete: "Interview Complete",
    Offer: "Offer",
    Withdrew: "Withdrew",
    Declined: "Declined",
    Hired: "Hired",
    Terminated: "Terminated",
    Assessment: "Assessment",
  },
  Invoice: {
    Type: {
      Job: "JOB",
      Client: "CLIENT",
      Commission: "COMMISSION",
    },
    Status: {
      Draft: "Draft",
      "Billed in QuickBooks": "Billed_In_QuickBooks",
      Paid: "Paid",
      "Not Paid": "Not_Paid",
    },
  },
  Users: { Type: { Source2: "SOURCE2", External: "EXTERNAL" } },
  DiscountStatus: { Actual: "actual", Estimated: "estimated" },
  CandidateType: {
    applied_hire: "Applied Hire",
    source_hired: "Sourced Hire",
    referral: "Referral",
    hiring_event: "Hiring Event",
    re_hired: "Rehire",
    re_hire_referral: "Rehire Referral",
    re_hire_applied: "Rehire Applied",
    re_hire_sourced: "Rehire Sourced",
    internal: "Internal",
    getAll() {
      return [
        { key: "applied_hire", label: this.applied_hire },
        { key: "source_hired", label: this.source_hired },
        { key: "referral", label: this.referral },
        { key: "hiring_event", label: this.hiring_event },
        { key: "re_hire_referral", label: this.re_hire_referral },
        { key: "re_hire_applied", label: this.re_hire_applied },
        { key: "re_hire_sourced", label: this.re_hire_sourced },
        { key: "internal", label: this.internal },
      ];
    },
  },
  CancelJobReasons: [
    { key: 1, value: "Position Filled Internally", input: false },
    { key: 2, value: "Role Not Approved/Budgeted", input: false },
    { key: 3, value: "Seasonality/Hiring Freeze", input: false },
    { key: 4, value: "Req Moved to Client/Internally", input: false },
    { key: 5, value: "Refreshing Position", input: false },
    { key: 6, value: "Job Requirements Reassessed", input: false },
    { key: 7, value: "Changing of Job Title", input: false },
    { key: 8, value: "Other", input: true },
  ],
  JobStatus: {
    open: "open-flag",
    closed: "closed-flag",
    "on hold": "onhold-flag",
    custom: "blue-flag",
  },
  JobStatusName: {
    Open: "Open",
    Closed: "Closed",
    OnHold: "On Hold",
    Cancelled: "Cancelled",
    Filled: "Filled",
    Pending: "Pending",
    Cancel: "Cancel",
  },
  Candidate: {
    DateFields: {
      statusChangedDate: {
        key: "statusChangedDate",
        label: "Status Change Date",
      },
      firstContactedDate: {
        key: "firstContactedDate",
        label: "First Contact Date",
      },
      secondContactedDate: {
        key: "secondContactedDate",
        label: "Second Contact Date",
      },
      thirdContactedDate: {
        key: "thirdContactedDate",
        label: "Third Contact Date",
      },
      applicationDate: {
        key: "applicationDate",
        label: "Applied Date",
      },
      phoneScreenCompleteDate: {
        key: "phoneScreenCompleteDate",
        label: "Phone Screen Complete Date",
      },
      s2InterviewScheduledDate: {
        key: "s2InterviewScheduledDate",
        label: "S2 Interview Scheduled Date",
      },
      dateSubmitted: {
        key: "dateSubmitted",
        label: "Date Submitted",
      },
      interviewDate: {
        key: "interviewDate",
        label: "Interview Date",
      },
      secondInterviewDate: {
        key: "secondInterviewDate",
        label: "Second Interview Date",
      },
      thirdInterviewDate: {
        key: "thirdInterviewDate",
        label: "Third Interview Date",
      },
      offerExtendedDate: {
        key: "offerExtendedDate",
        label: "Offer Extended Date",
      },
      startDate: {
        key: "startDate",
        label: "Start Date",
      },
      pendingStartDate: {
        key: "pendingStartDate",
        label: "Pending Start Date",
      },
    },
    Stages: {
      Prospect: "Prospect",
      Applied: "Applied",
      "Phone Screens": "Phone Screens",
      Submittals: "Submittals",
      Interviews: "Interviews",
      Offers: "Offers",
      Hires: "Hires",
      Closed: "Closed",
    },
  },
  RequisitionAgingThreshold: 90,
  Status: {
    Prospect: {
      id: 1,
      type: "active",
      name: "Prospect",
      subStatus: {
        Sourced: { id: 1, name: "Sourced" },
        FirstContacted: { id: 2, name: "First Contacted" },
        SecondContacted: { id: 3, name: "Second Contacted" },
        ThirdContacted: { id: 4, name: "Third Contacted" },
        NotInterested: { id: 43, name: "Not Interested" },
        Interested: { id: 44, name: "Interested" },
      },
    },
    Candidates: {
      id: 2,
      type: "active",
      name: "Candidates",
      subStatus: {
        NeedsReview: { id: 5, name: "Needs Review" },
        ReviewComplete: { id: 6, name: "Review Complete" },
      },
    },
    S2Interview: {
      id: 3,
      type: "active",
      name: "S2 Interview",
      subStatus: {
        Contacted: {
          id: 7,
          name: "Contacted",
          otherStatus: {
            FirstContacted: { id: 4, name: "First Contacted" },
            SecondContacted: { id: 5, name: "Second Contacted" },
            ThirdContacted: { id: 6, name: "Third Contacted" },
          },
        },
        Scheduled: { id: 8, name: "Scheduled" },
        Complete: { id: 9, name: "Complete" },
      },
    },
    Submitted: {
      id: 4,
      type: "active",
      name: "Submitted",
      subStatus: {
        AwaitingFeedback: { id: 10, name: "Awaiting Feedback" },
        SchedulingInterview: { id: 11, name: "Scheduling Interview" },
      },
    },
    ClientInterview: {
      id: 5,
      type: "active",
      name: "Client Interview",
      subStatus: {
        AwaitingFeedback: { id: 12, name: "Awaiting Feedback" },
        SecondInterview: { id: 46, name: "Second Interview" },
        ThirdInterview: { id: 45, name: "Third Interview" },
      },
    },
    Offer: {
      id: 6,
      type: "active",
      name: "Offer",
      ExtentedId: 13,
      AcceptedId: 14,
      subStatus: {
        Approval: { id: 47, name: "Approval" },
        Extended: { id: 13, name: "Extended" },
        Accepted: { id: 14, name: "Accepted" },
      },
    },
    Withdrew: {
      id: 7,
      type: "final",
      name: "Withdrew",
      subStatus: {
        Benefits: {
          id: 15,
          name: "Benefits",
        },
        Culture: {
          id: 16,
          name: "Culture",
        },
        DidNotDisclose: {
          id: 17,
          name: "Did Not Disclose",
        },
        Location: {
          id: 18,
          name: "Location",
        },
        NoLongerInterested: {
          id: 19,
          name: "No Longer Interested",
        },
        Pay: {
          id: 20,
          name: "Pay",
        },
        Requirements: {
          id: 21,
          name: "Requirements",
        },
        Schedule: {
          id: 22,
          name: "Schedule",
        },
        Unresponsive: {
          id: 33,
          name: "Unresponsive",
        },
      },
    },
    Declined: {
      id: 8,
      type: "final",
      name: "Declined",
      subStatus: {
        Assessment: {
          id: 34,
          name: "Assessment",
        },
        Background: {
          id: 35,
          name: "Background",
        },
        Communication: {
          id: 23,
          name: "Communication",
        },
        CulturalFit: {
          id: 24,
          name: "Cultural Fit",
        },
        DrugScreen: {
          id: 36,
          name: "Drug Screen",
        },
        Experience: {
          id: 25,
          name: "Experience",
        },
        Location: {
          id: 26,
          name: "Location",
        },
        MVR: {
          id: 37,
          name: "MVR",
        },
        NoShowToInterview: {
          id: 31,
          name: "No Show to Interview",
        },
        NotRehireable: {
          id: 51,
          name: "Not Rehireable",
        },
        OfferRescinded: {
          id: 48,
          name: "Offer Rescinded",
        },
        Pay: {
          id: 27,
          name: "Pay",
        },
        Physical: {
          id: 38,
          name: "Physical",
        },
        Professionalism: {
          id: 28,
          name: "Professionalism",
        },
        Requirements: {
          id: 29,
          name: "Requirements",
        },
        RequisitionClosed: {
          id: 32,
          name: "Requisition Closed",
        },
        Schedule: {
          id: 30,
          name: "Schedule",
        },
      },
    },
    Hired: {
      id: 9,
      type: "final",
      name: "Hired",
      subStatus: {
        StartedWork: {
          id: 39,
          name: "Started Work",
        },
      },
    },
    Terminated: {
      id: 10,
      type: "final",
      name: "Terminated",
      subStatus: {
        NoShowToDay1: {
          id: 40,
          name: "No Show to Day 1",
        },
        WithinGuarantee: {
          id: 41,
          name: "Within Guarantee",
        },
        WithinRetentionPeriod: {
          id: 42,
          name: "Within Retention Period",
        },
        OutsideRetentionPeriod: {
          id: 49,
          name: "Outside Retention Period",
        },
        OutsideGuarantee: {
          id: 50,
          name: "Outside Guarantee",
        },
      },
    },
    Assessment: {
      id: 12,
      type: "active",
      name: "Assessment",
      subStatus: {
        Sent: { id: 53, name: "Sent" },
        Complete: { id: 54, name: "Complete" },
      },
    },
    Type: {
      Active: "active",
      Final: "final",
      Hired: "hired",
    },
  },
  StatusDefinations: {
    ActiveCandidate:
      "Any candidate who is currently active in the recruitment process (submitted, interviewing, offer stage, pending start, etc.)",
    Prospect:
      "Any candidate who has been sent a solicitation and we are awaiting a response.",
    UnderReview:
      "Any candidate who has applied and their qualifications are currently being reviewed.",
    S2Interview:
      "Any candidate who is scheduled to conduct a Source2 phone interview.",
    Submittal:
      "Any candidate who has been submitted to the client hiring manager with feedback pending.",
    ClientInterview:
      "Any candidate who has a scheduled interview with the hiring manager with feedback pending.",
    OfferExtended:
      "Any candidate who has been extended an offer and we are awaiting a response.",
    OfferAccepted:
      "Any candidate who has accepted an offer but has not started work.",
    Hired: "Any candidate who has started work.",
  },
  EditComponentType: {
    CheckBox: "CheckBox",
    InputNumber: "InputNumber",
    InputText: "Input",
    DatePicker: "DatePicker",
    TimePicker: "TimePicker",
  },
  StatusTagColors: {
    Prospect: "var(--gray-200)",
    Candidates: "var(--pink-100)",
    Submitted: "var(--cyan-100)",
    Offer: "var(--green-100)",
    Withdrew: "var(--orange-200)",
    Declined: "var(--red-100)",
    Hired: "var(--green-300)",
    Terminated: "var(--red-100)",
    "S2 Interview": "var(--cyan-200)",
    "Client Interview": "var(--purple-200)",
    Assessment: "var(--blue-200)",
    "Interview Complete": "var(--sage-100)",
    "No Show to Day 1": "var(--red-100)",
    "Within Guarantee": "var(--orange-100)",
    "Outside Guarantee": "var(--red-100)",
    "Within Retention Period": "var(--orange-100)",
    "Outside Retention Period": "var(--red-100)",
  },
  DaysInStatusAlertLevel: {
    none: null,
    warning: "warning",
    critical: "critical",
  },
  DaysInStatusAlertLevelColors: {
    warning: "var(--warning-color)",
    critical: "var(--red-200)",
  },
  // Hex colors for pie chart (canvas does not resolve CSS variables).
  FalloutReasonColors: {
    Assessment: "#8571f4",
    Background: "#9d8df6",
    "Drug Screen": "#b6aaf8",
    MVR: "#45d0ee",
    "Not Rehireable": "#7ddef3",
    "Offer Rescinded": "#a2e7f6",
    Physical: "#eb4849",
    Benefits: "#ef6d6d",
    Culture: "#f39192",
    Location: "#f29d2a",
    Pay: "#f4b759",
    Schedule: "#f9dbac",
    Requirements: "#f8b5c4",
    Unresponsive: "#6ecda8",
    "Did Not Disclose": "#97dbc1",
    "No Longer Interested": "#999a9c",
    "No Show to Day 1": "#cccccd",
    Empty: "#f4f4f4",
  },
  EngagementStatus: {
    All: {
      ReadyForMilestoneCheckIn: {
        label: "Ready For Milestone Check-In",
        value: "ready_for_milestone_check_in",
        userAccessible: true,
      },
      OutreachFirstMade: {
        label: "Outreach 1 Made",
        value: "outreach_1_made",
        userAccessible: true,
      },
      OutreachSecondMade: {
        label: "Outreach 2 Made",
        value: "outreach_2_made",
        userAccessible: true,
      },
      Completed: {
        label: "Completed",
        value: "completed",
        userAccessible: true,
      },
      CompletedAtRisk: {
        label: "Completed At Risk",
        value: "completed_at_risk",
        userAccessible: true,
      },
      NotResponsive: {
        label: "Not Responsive",
        value: "not_responsive",
        userAccessible: true,
      },
      RecruiterMissed: {
        label: "Recruiter Missed",
        value: "recruiter_missed",
        userAccessible: false,
      },
      CandidateTerminated: {
        label: "Candidate Terminated",
        value: "candidate_terminated",
        userAccessible: false,
      },
    },

    byKey(key) {
      return Object.values(this.All).find((k) => k.value === key);
    },

    closed() {
      return [
        this.All.Completed,
        this.All.CompletedAtRisk,
        this.All.NotResponsive,
        this.All.RecruiterMissed,
        this.All.CandidateTerminated,
      ];
    },
  },
  InvoiceStatus: {
    Draft: "Draft",
    Billed_In_QuickBooks: "Billed In QuickBooks",
    Paid: "Paid",
    Not_Paid: "Not Paid",
  },
  CandidatePipeline: {
    StageKey: {
      Prospect: "prospect",
      Applied: "applied",
      PhoneScreen: "phone_screen",
      Submittals: "submittals",
      Interview: "interview",
      Assessment: "assessment",
      Offer: "offer",
      Hired: "hired",
      NotHired: "not_hired",
    },
    StageStatus: {
      Completed: "completed",
      Skipped: "skipped",
      Current: "current",
      Disabled: "disabled",
      Future: "future",
    },
  },
  UDF: {
    Entities: {
      Client: { id: 1, key: "client_id" },
      JobSource: { id: 2, key: "job_source_id" },
      Candidate: { id: 3, key: "candidate_job_entry_id" },
    },
    Fields: {
      1: {
        displayName: "Checkbox",
        type: "Checkbox",
        props: {},
        component: UDFOptions,
        displayComponent: UDFCheckbox,
        isDate: false,
        isTime: false,
        isMultiValue: true,
        isOption: true,
      },
      2: {
        displayName: "Radio",
        type: "Radio",
        props: {},
        component: UDFOptions,
        displayComponent: UDFRadio,
        isDate: false,
        isTime: false,
        isMultiValue: false,
        isOption: true,
      },
      3: {
        displayName: "Date",
        type: "DatePicker",
        props: {},
        component: null,
        displayComponent: UDFDatePicker,
        isDate: true,
        isTime: false,
        isMultiValue: false,
        isOption: false,
      },
      4: {
        displayName: "Time",
        type: "TimePicker",
        props: {},
        component: null,
        displayComponent: UDFTimePicker,
        isDateTime: false,
        isTime: true,
        isMultiValue: false,
        isOption: false,
      },
      5: {
        displayName: "Text",
        type: "Input",
        props: {},
        component: null,
        displayComponent: UDFInput,
        isDate: false,
        isTime: false,
        isMultiValue: false,
        isOption: false,
      },
      6: {
        displayName: "Text Area",
        type: "TextArea",
        props: {},
        component: null,
        displayComponent: UDFTextArea,
        isDate: false,
        isTime: false,
        isMultiValue: false,
        isOption: false,
      },
      7: {
        displayName: "Number",
        type: "InputNumber",
        props: {},
        component: null,
        displayComponent: UDFInputNumber,
        isDate: false,
        isTime: false,
        isMultiValue: false,
        isOption: false,
      },
      8: {
        displayName: "Select",
        type: "Select",
        props: {},
        component: UDFOptions,
        displayComponent: UDFSelect,
        isDate: false,
        isTime: false,
        isMultiValue: false,
        isOption: true,
      },
      9: {
        displayName: "Multi Select",
        type: "Select",
        props: { mode: "multiple" },
        component: UDFOptions,
        displayComponent: UDFSelect,
        isDate: false,
        isTime: false,
        isMultiValue: true,
        isOption: true,
      },
    },
  },
  Clients: {
    Reports: {
      Type: {
        RecruiterProductivity: "recruiter-productivity",
        Weekly: "weekly",
        Monthly: "monthly",
        Dashboard: "dashboard",
      },
    },
    SelectionType: {
      All: "all",
      None: "none",
    },
  },
  Sentry: {
    Dsn: process.env.REACT_APP_SENTRY_DSN,
    SampleRate: process.env.REACT_APP_SENTRY_SAMPLE_RATE,
    TracesSampleRate: process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE,
    replaysSessionSampleRate:
      process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate:
      process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  },
  BillingType: {
    Client: "CLIENT",
    Job: "JOB",
  },
  ViewTypes: {
    JobForm: "job_form",
    CandidateJobView: "candidate_job_view",
  },
};

export default K;
